import React from "react"
import styled from "styled-components"

const NavbarItemStyles = styled.li`
  margin-right: 1rem;
  padding: 0;
  :last-child {
    margin-right: 0;
  }
`

const NavbarItem = ({ children }) => (
  <NavbarItemStyles>{children}</NavbarItemStyles>
)

export default NavbarItem
